var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_383",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29212",
    "data-name": "Group 29212",
    transform: "translate(286 11197)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -286, -11197)",
    filter: "url(#Ellipse_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383-2",
    "data-name": "Ellipse 383",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_5_",
    "data-name": "svgexport-17 (5)",
    transform: "translate(-264 -11179.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49948",
    "data-name": "Path 49948",
    d: "M30.838,52.776H1.91l1.007-5.66a6.029,6.029,0,0,1,5.939-4.975H23.893a6.038,6.038,0,0,1,5.943,4.975Z",
    transform: "translate(-1.91 -23.001)",
    fill: "#5f566a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49949",
    "data-name": "Path 49949",
    d: "M32.829,49.03v7.43h-2.3V49.03a2.633,2.633,0,0,0,1.065.223h.174a2.635,2.635,0,0,0,1.065-.223Z",
    transform: "translate(-17.212 -26.685)",
    fill: "#3d2f46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28917",
    "data-name": "Group 28917",
    transform: "translate(13.902 25.347)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 0.562,
    cy: 0.562,
    rx: 0.562,
    ry: 0.562,
    fill: "#ced7dc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 0.562,
    cy: 0.562,
    rx: 0.562,
    ry: 0.562,
    transform: "translate(0 2.61)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49950",
    "data-name": "Path 49950",
    d: "M32.266,42.54a4.913,4.913,0,1,1-9.826,0,3.546,3.546,0,0,1,.02-.4h9.787A3.657,3.657,0,0,1,32.266,42.54Z",
    transform: "translate(-12.889 -23)",
    fill: "#3d2f46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49951",
    "data-name": "Path 49951",
    d: "M32.339,42.539a4.432,4.432,0,1,1-8.863,0,3.4,3.4,0,0,1,.02-.4H32.32A3.616,3.616,0,0,1,32.339,42.539Z",
    transform: "translate(-13.443 -23.001)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49952",
    "data-name": "Path 49952",
    d: "M32.565,33.73v4.221a2.991,2.991,0,0,1-2.845,3.119h-.174A2.991,2.991,0,0,1,26.7,37.951V33.73Z",
    transform: "translate(-15.167 -18.503)",
    fill: "#f8a771"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49953",
    "data-name": "Path 49953",
    d: "M31.89,10.054a11.184,11.184,0,0,1-.151,1.821c-.695,4.129-3.686,7.233-7.276,7.233s-6.582-3.1-7.276-7.233a11.2,11.2,0,0,1-.151-1.821c0-4.706,3.1-9.054,7.427-9.054S31.89,5.357,31.89,10.054Z",
    transform: "translate(-9.999 -1)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28918",
    "data-name": "Group 28918",
    transform: "translate(6.835 1.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49954",
    "data-name": "Path 49954",
    d: "M30.462,12.8c-1.88-2.659.877-5.963-1.655-8.316a1.333,1.333,0,0,1,1-.563c.89,0,1.647,1.243,1.938,2.984.3,1.811.064,4.9-1.282,5.9ZM18,12.807c1.88-2.659-.877-5.963,1.655-8.316a1.333,1.333,0,0,0-1-.564c-2.312,0-2.867,7.241-.656,8.88Z",
    transform: "translate(-16.602 -3.924)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28919",
    "data-name": "Group 28919",
    transform: "translate(6.835 1.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49955",
    "data-name": "Path 49955",
    d: "M30.462,12.779c-1.88-2.659.877-5.963-1.655-8.316,1.263-1.542,2.568.212,2.937,2.421.3,1.811.064,4.9-1.282,5.9ZM18,12.783c1.88-2.659-.877-5.963,1.655-8.316-1.263-1.542-2.568.212-2.937,2.42-.3,1.811-.064,4.9,1.282,5.9Z",
    transform: "translate(-16.602 -3.879)",
    fill: "#ced7dc"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 0.771,
    cy: 0.771,
    rx: 0.771,
    ry: 0.771,
    transform: "translate(10.767 8.581)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 0.771,
    cy: 0.771,
    rx: 0.771,
    ry: 0.771,
    transform: "translate(16.469 8.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49956",
    "data-name": "Path 49956",
    d: "M32.352,17.68q-.025-.214-.067-.426l-1.646.339A2.377,2.377,0,0,0,28.5,16.126a2.339,2.339,0,0,0-1.7.658,2.239,2.239,0,0,0-.494.672h0a1.258,1.258,0,0,0-1.388-.031v0a2.266,2.266,0,0,0-.46-.7A2.36,2.36,0,0,0,22.794,16a.185.185,0,0,0-.053-.005,2.374,2.374,0,0,0-2.148,1.37l-1.278-.324q-.022.254-.029.522l1.1.513v0a2.03,2.03,0,0,0-.019.237,2.377,2.377,0,0,0,2.318,2.429h.058a2.368,2.368,0,0,0,2.3-2.965.914.914,0,0,1,1.131.026,2.188,2.188,0,0,0-.106.641,2.38,2.38,0,0,0,2.323,2.434h.053a2.38,2.38,0,0,0,2.376-2.323,1.881,1.881,0,0,0-.01-.242Zm-7.6.736a1.989,1.989,0,0,1-.624,1.408,2.013,2.013,0,1,1-1.389-3.47h.044a2.02,2.02,0,0,1,1.413.624,1.992,1.992,0,0,1,.556,1.384v.053Zm3.644,2.1a2.016,2.016,0,0,1,.044-4.031h.048a2.016,2.016,0,0,1-.092,4.031Z",
    transform: "translate(-11.202 -9.017)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28920",
    "data-name": "Group 28920",
    transform: "translate(5.871 7.608)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 1.525,
    cy: 2.034,
    rx: 1.525,
    ry: 2.034,
    transform: "translate(14.136)",
    fill: "#fab687"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_425",
    "data-name": "Ellipse 425",
    cx: 1.525,
    cy: 2.034,
    rx: 1.525,
    ry: 2.034,
    fill: "#fab687"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49957",
    "data-name": "Path 49957",
    d: "M32.638,32.743a2.41,2.41,0,0,1-4.575-.037.38.38,0,0,1,.378-.471h3.828A.389.389,0,0,1,32.638,32.743Z",
    transform: "translate(-15.888 -17.704)",
    fill: "#663430"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49958",
    "data-name": "Path 49958",
    d: "M34,35a2.444,2.444,0,0,1-2.4.646l0,0A1.7,1.7,0,0,1,34,35Z",
    transform: "translate(-17.786 -19.055)",
    fill: "#ef4f63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandpa);
export default __webpack_public_path__ + "static/media/Grandpa.649701e7ef6fe4f715b9628606252155.svg";
export { ForwardRef as ReactComponent };